///<reference path="../../../typings/jsplumb/jquery.jsPlumb.d.ts"/>
///<reference path="processEditor-module.ts"/>
///<reference path="connectionDrawingService.ts"/>

module ProcessEditor {
    "use strict";

    export class ConditionInfoService {
        public fromConnectionEventInfo(info: IJsPlumbConnectionInfo, label: LabelOverlay) : ConditionInfo {
            var sourceEndpointId = info.sourceEndpoint.getUuid();
            var targetEndpointId = info.targetEndpoint.getUuid();
            return this.buildConditionInfo(label, sourceEndpointId, targetEndpointId);
        }

        public fromEndpointIds(sourceEndpointId:string, targetEndpointId:string, label: LabelOverlay): ConditionInfo {
            return this.buildConditionInfo(label, sourceEndpointId, targetEndpointId);
        }

        public fromConditionBranch(condition: ConditionBranch, label: LabelOverlay): ConditionInfo {
            var sourceEndpointId = condition.sourceEndpointId;
            var targetEndpointId = condition.targetEndpointId;
            angular.element(label.canvas).data("conditionId", condition.conditionId);
            return this.buildConditionInfo(label, sourceEndpointId, targetEndpointId);
        }

        private buildConditionInfo(labelOverlay: LabelOverlay, sourceEndpointId: string, targetEndpointId: string) : ConditionInfo {
            // When gathering information about NEW condition branches, this method should generate a new unique condition ID.
            // When gathring informationa about pre-existing branches, it should return the original ID.
            // In order to determine if the branch is new or not, the generated ID is stored in the data attribute of the label.

            let label = angular.element(labelOverlay.canvas);
            const conditionId: any = label.data("conditionId") || generateUniqueConditionId(sourceEndpointId);
            const formId = "#conditionForm_" + conditionId;
            const formContainerId = "#" + conditionId;
            label.data("conditionId", conditionId);
            // also reset the ID for the element so we can refer to it easily in validation to set the error border etc.
            label.attr("id", `label_${conditionId}`);

            return new ConditionInfo(
                conditionId,
                labelOverlay,
                formId,
                formContainerId,
                sourceEndpointId,
                targetEndpointId
            );
        }
    }
    app.service("ConditionInfoService", ConditionInfoService);
}